import { Table as MantineTable } from '@mantine/core';

export const Table = Object.assign(MantineTable, {});
